exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{display:block}.modal-content{max-width:100%;margin:0;top:0;bottom:0;left:0;right:0;height:100vh;display:flex;background-color:transparent}.alert{margin-top:.5rem!important;margin-bottom:.5rem!important}#btn-reload{position:absolute;right:0;bottom:0;margin-bottom:0}#div-save{padding:.84375rem 0}#div-save button{margin-bottom:0}", ""]);

// exports
